import _ from 'lodash';

export default class Compare {
    static holdsEqual     = (holds1, holds2) => _.map(holds1, 'key').sort().join('') === _.map(holds2, 'key').sort().join('');
    static shortcutsEqual = (shortcuts1, shortcuts2) => _.map(shortcuts1, 'keys').map(keys => [...keys].sort().join('')).sort().join() === _.map(shortcuts2, 'keys').map(keys => [...keys].sort().join('')).sort().join();
}
